import React from 'react';
import { ModalContainer } from '../styles';
import { ModalFactory } from '../../../../../components/modal/modal';
import CommonButton from '../../../../../components/common-button/CommonButton';
import { SAMPLE_PASSPORT_IMAGE_ICON } from '@Images';

export const openSampleModal = async (cmsData?: Record<string, string>): Promise<any> => {
  //@ts-ignore
  await ModalFactory.builder(
    //@ts-ignore
    (onClose) => (
      <ModalContainer
        containerMarginTop={0}
        buttonTopMargin={16}
        buttonWidth={418}
        height={479}
        width={458}
      >
        <div className="modal-body-container">
          <div className="header-container">
            <span className="__heading">{cmsData?.passportSampleHeading || `Passport`}</span>
            <span className="__heading-desc">
              {cmsData?.passportSampleSubHeading || `Sample illustration`}
            </span>
          </div>
          <img alt="sample-passport" src={SAMPLE_PASSPORT_IMAGE_ICON} className="sample-passport" />
          <span className="sample-passport-desc">
            {cmsData?.passportSampleFooter ||
              `As shown in the illustration here, open personal details section and capture both pages
            clearly.`}
          </span>
          <div className="modal-submit-button-container">
            <CommonButton
              text={cmsData?.passportSampleOKCTA || `Got it`}
              onClick={() => onClose(true)}
              width={426}
            />
          </div>
        </div>
      </ModalContainer>
    ),
    'send-money-bene-modal insta-modal center-modal',
    true
  );
};
